
export default {
  data: function data() {
    return {
      text: null,
      background: null,
      visible: false,
      icon: null,
      customClass: ''
    };
  },

  computed: {
    iconUrl: function iconUrl() {
      /** 内置几个类型  当时none的时候  不展示 */
      if (this.icon) {
        if (this.icon === 'none') {
          return '';
        } else if (this.icon === 'nopermission') {
          return require('@/assets/img/nopermission.png');
        } else {
          return require('@/assets/img/empty.png');
        }
      } else {
        return require('@/assets/img/empty.png');
      }
    },
    showText: function showText() {
      /** 内置几个类型  当时none的时候  不展示 */
      if (this.text) {
        return this.text;
      } else {
        return '没有找到数据';
      }
    }
  },
  methods: {
    setText: function setText(text) {
      if (text) {
        this.text = text;
      }
    },
    setIcon: function setIcon(icon) {
      this.icon = icon;
    }
  }
};